import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import Layout from '../components/Layout';
import ProductCard from '../components/ProductCard';
import { useSanityProducts } from '../hooks/useSanityProducts';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../data/seoMeta';

function BelloFlexPage() {
  var { t } = useTranslation();
  var { products } = useSanityProducts({ category: 'mutes' });

  return (
    <Layout>
      <SEO title={PAGE_SEO['belloflex'].title} description={PAGE_SEO['belloflex'].description} url="/belloflex" />
      <div className="pt-32 pb-20 bg-black min-h-screen">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-12">
            <p className="text-[#d4af37] text-sm tracking-widest uppercase mb-4">{t('innovation')}</p>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">BelloFlex Mutes</h1>
            <p className="text-xl text-neutral-400 max-w-2xl mx-auto">
              {t('professionalMutes')}
            </p>
          </div>

          {/* Limited Warranty Banner */}
          <div data-testid="belloflex-warranty-banner" className="mb-16 mx-auto max-w-3xl">
            <div className="relative overflow-hidden rounded-2xl border border-[#d4af37]/30 bg-gradient-to-br from-[#d4af37]/10 to-transparent p-8 md:p-10">
              <div className="flex flex-col items-center text-center">
                <Shield className="w-12 h-12 text-[#d4af37] mb-4" />
                <h2 className="text-3xl md:text-4xl font-bold text-[#d4af37] mb-4">
                  {t('belloFlexLifetimeWarranty')}
                </h2>
                <p className="text-neutral-300 text-base md:text-lg max-w-2xl mb-4">
                  {t('belloFlexWarrantyText')}
                </p>
                <p className="text-neutral-500 text-sm max-w-2xl mb-4">
                  {t('belloFlexWarrantyExclusions')}
                </p>
                <p className="text-neutral-500 text-sm">
                  {t('belloFlexWarrantyDetails')}{' '}
                  <Link to="/refund" className="text-[#d4af37] hover:underline">
                    {t('refundPolicy')}
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map(function(product) {
              return <ProductCard key={product.slug || product._id} product={product} />;
            })}
          </div>

          <div className="text-center mt-16">
            <Link
              to="/shop"
              className="inline-flex items-center gap-2 text-[#d4af37] hover:text-white transition-colors text-lg"
            >
              {t('viewAllProducts')} →
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default BelloFlexPage;
